import { DeleteForeverRounded } from '@mui/icons-material';
import { Box, Typography, alpha } from '@mui/material';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { removeCatalogItemActions } from 'features/removeCatalogItem/model/slices/RemoveCatalogItemSlice';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';
import { useInitialEffect } from 'shared/lib/hooks/useInitialEffect';

import { RemoveCatalogItemDialog } from '../RemoveCatalogItemDialog/RemoveCatalogItemDialog';

interface RemoveCatalogItemProps {
    isSingleItem?: boolean;
    onSuccess?: () => void;
}

export const RemoveCatalogItem = memo(
    ({ isSingleItem, onSuccess }: RemoveCatalogItemProps) => {
        const { t } = useTranslation();
        const dispatch = useAppDispatch();

        useInitialEffect(() => {
            dispatch(removeCatalogItemActions.setIsSingle(isSingleItem));
        });

        useEffect(() => {
            dispatch(removeCatalogItemActions.setIsSingle(isSingleItem));
        }, [dispatch, isSingleItem]);

        const onShowDeleteDialog = () => {
            dispatch(removeCatalogItemActions.setShowDialog(true));
        };

        return (
            <>
                <Box
                    display="flex"
                    alignItems="center"
                    sx={(theme) => ({
                        cursor: 'pointer',
                        gap: '4px',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: '#E8EEF6',
                        },
                    })}
                    onClick={onShowDeleteDialog}
                >
                    <DeleteForeverRounded
                        sx={(theme) => ({
                            fontSize: '20px',
                            width: '20px',
                            height: '20px',
                            color: alpha(theme.palette.text.disabled, 0.6),
                        })}
                    />
                    <Typography
                        sx={(theme) => ({
                            color: alpha(theme.palette.text.disabled, 0.6),
                        })}
                        typography="openSans.subtitle2"
                    >
                        {t('Remove')}
                    </Typography>
                </Box>
                <RemoveCatalogItemDialog onSuccess={onSuccess} />
            </>
        );
    },
);
